import cardSvg from "../../assets/images/svgs/card.svg";
import bankSvg from "../../assets/images/svgs/bank.svg";
import career from "../../assets/images/svgs/bookmark.svg";
import people from "../../assets/images/svgs/people.svg";
import statementSvg from "../../assets/images/svgs/statement.svg";
import announcement from "../../assets/images/svgs/announcement.svg";
import fee from "../../assets/images/svgs/fee.svg";
import faq from "../../assets/images/svgs/document.svg";

export const envMapper = {
  TEST: {
    id: 1,
    env: "luaa.com.ng:8081",
  },
  PROD: {
    id: 2,
    env: "luaa.com.ng:8081",
  },
  LOCAL_HOST: {
    id: 3,
    env: ":8081",
  },
};

export const subDomainMapper = {
  TEST: {
    id: 1,
    subDomain: "base",
    api_env: envMapper.TEST,
  },
  PROD: {
    id: 2,
    subDomain: "base",
    api_env: envMapper.PROD,
  },
  LOCAL_HOST: {
    id: 3,
    subDomain: "localhost",
    api_env: envMapper.LOCAL_HOST,
  },
};

export const docTypeMapper = (docType) => {
  let path;
  switch (docType) {
    case "ENGLISH_WAIVER":
      path = "/document-processing/english-waiver";
      break;
    case "CERTIFICATE_PROCESSING":
      path = "/document-processing/certificate";
      break;
    case "RECOMMENDATION_LETTER":
      path = "/document-processing/recommendation-letter";
      break;
    case "TRANSCRIPT_OFFICIAL":
      path = "/document-processing/transcript-official";
      break;
    case "TRANSCRIPT_UNOFFICIAL":
      path = "/document-processing/transcript-unofficial";
      break;
    default:
      path = "/document-processing/certificate";
      break;
  }
  return path;
};

export const documentTypeMapper = [
  { name: "Document Tracking", path: "document-processing/tracking" },

  { name: "Certificate Processing", path: "document-processing/certificate" },
  {
    name: "Transcript Official",
    path: "document-processing/transcript-official",
  },
  {
    name: "Unofficial Transcript",
    path: "document-processing/transcript-unofficial",
  },
  { name: "Official Letter", path: "document-processing/official_letter" },

  // {
  //   name: "Recommendation Letter",
  //   path: "/document-processing/recommendation-letter",
  // },
];

export const quickMenuMap = [
  {
    id: 1,
    to: "document-processing",
    icon: "fa fa-file-invoice",
    iconSvg: statementSvg,
    name: "Document Processing",
    nameConst: "DOC_PROCESSING",
    visibleTo: ["ROLE_SYSTEM_ADMIN", "ROLE_SUPER_ADMIN"],
  },
  {
    id: 2,
    to: "community",
    icon: "fa fa-user-plus",
    iconSvg: bankSvg,
    name: "Communities",
    nameConst: "COMMUNITIES",
    visibleTo: ["ROLE_SYSTEM_ADMIN", "ROLE_SUPER_ADMIN"],
  },
  {
    id: 3,
    to: "events",
    icon: "fa fa-user-plus",
    iconSvg: cardSvg,
    name: "Events",
    nameConst: "EVENTS",
    visibleTo: ["ROLE_SYSTEM_ADMIN", "ROLE_SUPER_ADMIN"],
  },
  {
    id: 4,
    to: "members",
    icon: "fa fa-user-plus",
    iconSvg: people,
    name: "Members",
    nameConst: "MEMBERS",
    visibleTo: ["ROLE_SYSTEM_ADMIN", "ROLE_SUPER_ADMIN"],
  },
  {
    id: 6,
    to: "announcements",
    icon: "fa fa-user-plus",
    iconSvg: announcement,
    name: "Announcement",
    nameConst: "ANNOUNCEMENT",
    visibleTo: ["ROLE_SYSTEM_ADMIN", "ROLE_SUPER_ADMIN"],
  },
  {
    id: 7,
    to: "fee",
    icon: "fa fa-user-plus",
    iconSvg: fee,
    name: "Fee",
    nameConst: "FEE",
    visibleTo: ["ROLE_SYSTEM_ADMIN", "ROLE_SUPER_ADMIN"],
  },
  {
    id: 8,
    to: "faq",
    icon: "fa fa-user-plus",
    iconSvg: faq,
    name: "Faq",
    nameConst: "FAQ",
    visibleTo: ["ROLE_SYSTEM_ADMIN", "ROLE_SUPER_ADMIN"],
  },
  {
    id: 9,
    to: "career-job",
    icon: "fa fa-user-plus",
    iconSvg: career,
    name: "Career",
    nameConst: "CAREER",
    visibleTo: ["ROLE_SYSTEM_ADMIN", "ROLE_SUPER_ADMIN"],
  },
  {
    id: 10,
    to: "career-scholarship",
    icon: "fa fa-user-plus",
    iconSvg: career,
    name: "Scholarship",
    nameConst: "SCHOLARSHIP",
    visibleTo: ["ROLE_SYSTEM_ADMIN", "ROLE_SUPER_ADMIN"],
  },
  {
    id: 11,
    to: "delivery-fees",
    icon: "fa fa-user-plus",
    iconSvg: fee,
    name: "Delivery Fee",
    nameConst: "FEE",
    visibleTo: ["ROLE_SYSTEM_ADMIN", "ROLE_SUPER_ADMIN"],
  },
];

export const feeTypes = [
  { id: 1, name: "Alumni Fee", value: "ALUMNI_FEE" },
  { id: 2, name: "Certificate Processing", value: "CERTIFICATE_PROCESSING" },
  { id: 3, name: "Transcript Official", value: "TRANSCRIPT_OFFICIAL" },
  { id: 4, name: "Transcript UnOfficial", value: "TRANSCRIPT_UNOFFICIAL" },
  { id: 5, name: "English Waiver", value: "ENGLISH_WAIVER" },
  { id: 6, name: "Recommendation Letter", value: "RECOMMENDATION_LETTER" },
  { id: 7, name: "Mixed Request", value: "MIXED_REQUEST" },
];

export const documentFormats = [
  { id: 1, name: "Hard Copy", value: "HARD_COPY" },
  { id: 2, name: "Soft Copy", value: "SOFT_COPY" },
];

export const transcriptTypes = [
  { id: 1, name: "Local", value: "LOCAL" },
  { id: 2, name: "Foreign", value: "FOREIGN" },
];

export const documentTypes = [
  { name: "Others", value: "OTHERS" },
  { name: "Notification of Result", value: "NOTIFICATION_OF_RESULT" },
  { name: "School ID Card", value: "SCHOOL_ID_CARD" },
  { name: "Police Report", value: "POLICE_REPORT" },
  { name: "Court Affidavit", value: "COURT_AFFIDAVIT" },
  { name: "Certificate", value: "CERTIFICATE" },
];

export const costTypes = [
  { id: 1, name: "Others", value: "OTHERS" },
  { id: 2, name: "Certificate Processing", value: "CERTIFICATE_PROCESSING" },
  { id: 3, name: "Transcript Official", value: "TRANSCRIPT_OFFICIAL" },
  { id: 4, name: "Transcript UnOfficial", value: "TRANSCRIPT_UNOFFICIAL" },
  { id: 5, name: "English Waiver", value: "ENGLISH_WAIVER" },
  { id: 6, name: "Recommendation Letter", value: "RECOMMENDATION_LETTER" },
  { id: 7, name: "Alumni Fee", value: "ALUMNI_FEE" },
];
